import type { InstructionStatusName, InstructionClientStatusName } from '@models/next/Instruction';
import { createStrings } from '@utils/local';

export const instructionStrings = createStrings({
  ja: {
    receiver: '納品先',
    deliveryInstruction: '納品の最終確認',
    customsInstruction: '通関書類のアップロードと海上保険',
    managementInformation: '管理情報',
    deadline: '締め切り',
    status: 'ステータス',
    requireChange: '修正依頼',
    requireChangeSuccess: '修正依頼が送信されました。',
    changeRequired: '修正依頼済',
    customsConfirmed: '通関依頼済',
    deliveryConfirmed: '配達手配済',
    filesConfirmed: '書類確認済',
    customsFiles: '通関書類',
    customsRelatedFiles: '通関資料',
    deliveryFiles: '配車書類',
    deliveryFinalConfirmation: '納品の最終確認',
    commodities: '商品説明',
    uploadFiles: '書類アップロード',
    downloadFiles: '書類ダウンロード',
    rcepUsage: 'RCEPのご利用',
    rcepFile: '中国原産地証明書',
    useRcep: 'RCEP（アールセップ）を利用する',
    notUseRcep: 'RCEP（アールセップ）を利用しません',
    hasConfirmedReceiver: `下記の内容で間違いありません。`,
    truck: 'トラック',
    truckChoice: '日本国内配送方法',
    deliveryMethod: '配送方法',
    deliveryFee: '見積合計金額',
    deliveryDate: '最短納品可能日',
    deliveryDateMemo: 'その他（希望の納品日を特記事項にご記入ください）',
    deliveryTime: '納品時間',
    noDecidedDeliveryTime: '届け時間指定不可',
    preferredDeliveryDate: '納品希望日',
    seaInsurance: '海上保険',
    seaInsuranceUsage: '海上保険のご利用',
    preferIndividualInsurance: '個別保険を利用する',
    preferBlanketInsurance: '包括保険を利用する',
    preferNoInsurance: '保険を利用しない',
    insuranceCompany: '保険会社',
    insurancePolicyNo: '証券番号',
    insurancePeriod: '保険期間',
    insurancePeriodStart: '保険期間開始日',
    insurancePeriodEnd: '保険期間終了日',
    additionalFiles: '添付資料',
    blanketInsuranceFiles: '包括保険添付資料',
    individualInsuranceFiles: '個人保険証券',
    requestChangesReason: '修正理由',
    truckMemoRequested:
      'トラックや納品希望日などを指定しない場合は、特記事項で詳細をご提供ください。',
    insuranceBlanketStartGtEnd: '無効な保険期間です',
    insuranceBlanketExpired: '保険期間が切れました',
    needValidReceiver: '納品先を確認しない場合は、改めて納品先を正しく入力してください。',
    otherTruckOptions: '希望のトラックオプションと配達時間帯を特記事項にご記入ください',
    isOverdue: '締切が切れました',
    pleaseContactD2dCustomerCenter: '必ずD2D カスタマーセンターに連絡してください。',
    deliveryTimeOptions: {
      '': [],
      その他: [],
      mix: [{ label: '指定しない', value: '指定しない' }],
      '4T': [
        { label: '配達当日朝9:00', value: '配達当日朝9:00' },
        { label: 'その他（希望の時間帯を特記事項にご記入ください）', value: 'その他' },
      ],
      '4Tx2': [
        { label: '配達当日朝9:00', value: '配達当日朝9:00' },
        { label: 'その他（希望の時間帯を特記事項にご記入ください）', value: 'その他' },
      ],
      '10T': [
        { label: '配達当日朝9:00', value: '配達当日朝9:00' },
        { label: 'その他（希望の時間帯を特記事項にご記入ください）', value: 'その他' },
      ],
    },
    '': '',
    mix: '混載便',
    '4T': 'チャーター便 (4T)',
    '4Tx2': 'チャーター便 (4T 2台)',
    '10T': 'チャーター便 (10T)',
    その他: 'その他',
    deliveryOptionTags: {
      '': [{ color: 'primary', text: '車上渡し' }],
      その他: [{ color: 'primary', text: '車上渡し' }],
      mix: [
        { color: 'error', text: '割安' },
        { color: 'primary', text: '車上渡し' },
        { color: 'grey', text: '時間指定不可' },
      ],
      '4T': [
        { color: 'primary', text: '車上渡し' },
        { color: 'primary', text: '時間指定可' },
      ],
      '4Tx2': [
        { color: 'primary', text: '車上渡し' },
        { color: 'primary', text: '時間指定可' },
      ],
      '10T': [
        { color: 'primary', text: '車上渡し' },
        { color: 'primary', text: '時間指定可' },
      ],
    } as const,
    insuranceTags: {
      INDIVIDUAL: '個別保険',
      BLANKET: '包括保険',
      NA: '利用しない',
    },
    blanketInsuranceList: '包括保険一覧',
    confirmed: '確認済み',
    customerInstructionNotReady: '顧客指示未',
    customerInstructionBeingRevised: '顧客指示修正中',
    customerInstructionCompleted: '顧客指示済',
    specialNote: '特記事項',
    specialNoteDetails: '特記事項詳細',
    specialNoteTitle: '特記事項タイトル',
    specialNoteNote: '特記事項内容',
    customsInstructionSpecialNote: '通関に関する特記事項',
    deliveryInstructionSpecialNote: '国内トラック配送に関する特記事項',
    deliveryInstructionSpecialNoteShort: '国内配送に関する特記事項',
    customsInstructionHasSpecialNoteTrue: '通関に関する特記事項あり',
    customsInstructionHasSpecialNoteFalse: '通関に関する特記事項なし',
    deliveryInstructionHasSpecialNoteTrue: '国内トラック配送に関する特記事項あり',
    deliveryInstructionHasSpecialNoteFalse: '国内トラック配送に関する特記事項なし',
    customsInstructionSpecialNotePlaceholder: (title: string) =>
      `${title}についてご要望があれば、こちらに記載してください。`,
    deliveryInstructionSpecialNotePlaceholder:
      '特記事項ありを選択した場合、こちらのご入力は必須です。\n例：商品の一辺のサイズが2メートル以上・1個の商品重量が1000KGS以上・車両の種類（ユニック車・平車）など。',
    errorEmptySpecialNote: '特記事項詳細を入力してください',
    errorAlreadyConfirmed: '既に確認されました。',
    errorBlanketInsuranceEndBeforeStart: '保険期限の開始日は期限日より遅いです。',
  },
});

export const customsInstructionSpecialNoteTitles = [
  '個別評価申告',
  '包括評価申告',
  '食品申請',
  '化粧品関係書類',
  '医療機器を扱うライセンス',
  '知的財産許諾書',
  'その他',
];

export type InstructionStatusMeta = {
  editable: boolean;
  isSent: boolean;
  adminLabel: string;
  clientLabel: InstructionClientStatusName;
  shortAdminLabel: string;
};

export const instrunctionStatusMetas: Record<InstructionStatusName, InstructionStatusMeta> = {
  未送信: {
    editable: true,
    isSent: false,
    adminLabel: instructionStrings.customerInstructionNotReady,
    clientLabel: '未送信',
    shortAdminLabel: '受信未',
  },
  送信済: {
    isSent: true,
    editable: false,
    adminLabel: instructionStrings.customerInstructionCompleted,
    clientLabel: '送信済',
    shortAdminLabel: '受信済',
  },
  修正依頼済: {
    isSent: false,
    editable: true,
    adminLabel: instructionStrings.customerInstructionBeingRevised,
    clientLabel: '修正してください',
    shortAdminLabel: '修正中',
  },
  確認済み: {
    isSent: true,
    editable: false,
    adminLabel: instructionStrings.filesConfirmed,
    clientLabel: '確認済み',
    shortAdminLabel: '確認済',
  },
};

export const getInstructionStatusMeta = (name: InstructionStatusName) =>
  instrunctionStatusMetas[name];

export const getInstructionStatusLabel = (name: InstructionStatusName, isAdmin: boolean) => {
  const meta = getInstructionStatusMeta(name);

  if (meta.adminLabel && isAdmin) {
    return meta.adminLabel;
  }

  if (meta.clientLabel && !isAdmin) {
    return meta.clientLabel;
  }

  return name;
};

export const getInstructionStatusByClientLabel = (name: InstructionClientStatusName) => {
  return Object.entries(instrunctionStatusMetas).find(
    ([_, m]) => m.clientLabel === name,
  )![0] as InstructionStatusName;
};
